import axios from 'axios';
import { env } from '@/config/env';

// Axios instance for public, unauthenticated requests.
// - Does not attach Authorization header
// - Does not redirect on 401
export const publicClient = axios.create({
  baseURL: env.apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

